
import PublicSecondaryLoginPage from '../../svg/PublicSecondaryLoginPage';
import { useNavigate } from 'react-router-dom';
import Logo from '../../svg/Logo.js'
import Footer from '../../svg/Footer.js';


export default function SecondaryLogin(props) {
  const navigate = useNavigate();
  return (
    <div className='w-full h-full overflow-auto bg-[#DFFFFA] relative'>
      <div className='flex flex-col justify-start items-center w-[100%] bg-[#DFFFFA] relative' style={{ overflow: 'auto', aspectRatio: 1920 / 2160, height: undefined }}>
        <PublicSecondaryLoginPage width='100%' onClick={() => { navigate('/edb1/missions') }} />
        <div className='w-full fixed flex flex-row items-center justify-start bg-[#DFFFFA] p-[16px]'>
          <Logo width={'25%'} className='max-w-[250px]'/>
        </div>
        <div className='w-full fixed bottom-0'>
          <Footer width='100%' />
        </div>
      </div>
    </div>
  )
}